import { FileX2, Film, Scissors, SquareUserRound } from "lucide-react";

const ICONS = { post: SquareUserRound, replay: Film, clip: Scissors, file: FileX2 };

export const TakedownCard = ({ type, title, description, value, onValueChange, onReview, onChildSafety }) => {
  const Icon = ICONS[type];
  const inputId = `takedown-${type}-identifier`;
  return (
    <article className="takedown-card" data-testid={`takedown-${type}-card`}>
      <div className="takedown-card-heading"><span><Icon size={20} /></span><div><h2>{title}</h2><p>{description}</p></div></div>
      <label htmlFor={inputId}>{type === "file" ? "Object path" : `${title} ID`}</label>
      <input id={inputId} value={value} onChange={(event) => onValueChange(event.target.value)} placeholder={type === "file" ? "auralive/…" : `Enter ${type} ID`} data-testid={`takedown-${type}-identifier-input`} />
      <div className="takedown-card-actions">
        <button className="button secondary" onClick={onReview} disabled={!value.trim()} data-testid={`review-${type}-takedown-button`}>Review removal</button>
        <button className="button child-safety" onClick={onChildSafety} disabled={!value.trim()} data-testid={`child-safety-${type}-button`}>Child-safety / CSAE</button>
      </div>
    </article>
  );
};